// Order for 4 sentences for step 5, 6, 7 
// because first picture has to be last, not chosen picture
// in step 4 - so is set in step 4
// - here also predefined for testing purposes


// The sentence currently worked with on step 5-6-7
// - because step 5-6-7 first run with one sentence,
// - then again with the next until all 4 sentences used
// so we can go on to the last steps - step 8 and 9
class CurrentSentenceNumberForSteps {
  value = $state<number>(0);
}

// indexes for targets for step 5-6-7: on extra to avoid undefined on last task step 7
class TargetsForSteps {
  value = $state<Array<number>>([3, 0, 2, 1, 1]);
}

export const currentSentenceNumberForSteps = new CurrentSentenceNumberForSteps();
export const targetsForSteps = new TargetsForSteps();
